import React from 'react';

interface SiteCardProps {
  site: any;
  onEdit: (site: any) => void;
  onDelete: (site: any) => void;
  isSelected?: boolean;
  onToggleSelection?: () => void;
  canEdit?: boolean;
  canDelete?: boolean;
  canBulk?: boolean;
}

const SiteCard: React.FC<SiteCardProps> = ({ 
  site, 
  onEdit, 
  onDelete, 
  isSelected = false, 
  onToggleSelection,
  canEdit = false,
  canDelete = false,
  canBulk = false
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-3 hover:shadow-md transition-shadow">
      {/* En-tête avec case à cocher, nom et actions */}
      <div className="flex items-start gap-2 mb-2">
        {/* Case à cocher à gauche */}
        {onToggleSelection && canBulk && (
          <label className="flex-shrink-0 cursor-pointer mt-0.5">
            <input
              type="checkbox"
              checked={isSelected}
              onChange={onToggleSelection}
              className="form-checkbox h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-500"
              onClick={(e) => e.stopPropagation()}
            />
          </label>
        )}
        
        {/* Contenu principal */}
        <div className="flex items-start justify-between gap-2 flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <h3 className="font-semibold text-gray-900 text-sm truncate">{site.nom}</h3>
            {site.trigram && (
              <span className="px-2 py-0.5 text-xs font-medium rounded bg-green-100 text-green-800 flex-shrink-0">
                {site.trigram}
              </span>
            )}
          </div>
          {(canEdit || canDelete) && (
            <div className="flex gap-1 flex-shrink-0">
              {canEdit && (
                <button
                  onClick={() => onEdit(site)}
                  className="text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50"
                  title="Modifier"
                >
                  ✏️
                </button>
              )}
              {canDelete && (
                <button
                  onClick={() => onDelete(site)}
                  className="text-red-600 hover:text-red-800 p-1 rounded hover:bg-red-50"
                  title="Supprimer"
                >
                  🗑️
                </button>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Adresse */}
      {site.adresse && (
        <p className="text-sm text-gray-600 mb-2">📍 {site.adresse}</p>
      )}

      {/* Lien Google Maps */}
      {site.googleMapsUrl && (
        <div className="mb-2">
          <a 
            href={site.googleMapsUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-xs text-blue-600 hover:text-blue-800 underline"
          >
            🗺️ Voir sur Google Maps
          </a>
        </div>
      )}

      {/* Statistiques */}
      <div className="flex items-center gap-3 text-xs text-gray-500">
        <span className="flex items-center gap-1">
          <span>🏗️</span>
          <span>{site.batiments?.length || 0} bâtiments</span>
        </span>
        <span className="flex items-center gap-1">
          <span>🚪</span>
          <span>{site.batiments?.reduce((total: number, bat: any) => total + (bat.pieces?.length || 0), 0) || 0} pièces</span>
        </span>
        <span className="flex items-center gap-1">
          <span>📦</span>
          <span>{site.batiments?.reduce((total: number, bat: any) => 
            total + (bat.pieces?.reduce((pTotal: number, piece: any) => 
              pTotal + (piece.zones?.length || 0) + (piece.boxes?.length || 0), 0) || 0), 0) || 0} zones/boxes</span>
        </span>
      </div>
    </div>
  );
};

export default SiteCard;
